// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import PlanResource from "./plan-resource.js"
import Subscription from "./subscription.js"

const modelClassData = {
  "attributes": {
    "auto_renew": {
      "column": {
        "default": "0",
        "name": "auto_renew",
        "null": false,
        "type": "boolean"
      },
      "name": "auto_renew",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "description_with_inline_styling": {
      "column": null,
      "name": "description_with_inline_styling",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "position": {
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": false
    },
    "show_in_sign_up_modal": {
      "column": {
        "default": "0",
        "name": "show_in_sign_up_modal",
        "null": false,
        "type": "boolean"
      },
      "name": "show_in_sign_up_modal",
      "selected_by_default": null,
      "translated": false
    },
    "uniqueness_identifier": {
      "column": {
        "default": null,
        "name": "uniqueness_identifier",
        "null": true,
        "type": "string"
      },
      "name": "uniqueness_identifier",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "description": {
      "column": null,
      "name": "description",
      "selected_by_default": false,
      "translated": true
    },
    "description_da": {
      "column": null,
      "name": "description_da",
      "selected_by_default": false,
      "translated": false
    },
    "description_en": {
      "column": null,
      "name": "description_en",
      "selected_by_default": false,
      "translated": false
    },
    "description_no": {
      "column": null,
      "name": "description_no",
      "selected_by_default": false,
      "translated": false
    },
    "description_se": {
      "column": null,
      "name": "description_se",
      "selected_by_default": false,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    },
    "sub_title": {
      "column": null,
      "name": "sub_title",
      "selected_by_default": false,
      "translated": true
    },
    "sub_title_da": {
      "column": null,
      "name": "sub_title_da",
      "selected_by_default": false,
      "translated": false
    },
    "sub_title_en": {
      "column": null,
      "name": "sub_title_en",
      "selected_by_default": false,
      "translated": false
    },
    "sub_title_no": {
      "column": null,
      "name": "sub_title_no",
      "selected_by_default": false,
      "translated": false
    },
    "sub_title_se": {
      "column": null,
      "name": "sub_title_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "Plan",
  "collectionKey": "plans",
  "collectionName": "plans",
  "i18nKey": "plan",
  "camelizedLower": "plan",
  "name": "Plan",
  "nameDasherized": "plan",
  "pluralName": "plans",
  "ransackable_associations": [
    {
      "className": "Plan::Audit",
      "collectionName": "plan_audits",
      "foreignKey": "plan_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "PlanAudit",
      "through": null
    },
    {
      "className": "Plan::Audit",
      "collectionName": "plan_audits",
      "foreignKey": "plan_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "PlanAudit",
      "through": null
    },
    {
      "className": "Plan::Translation",
      "collectionName": null,
      "foreignKey": "plan_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "PlanResource",
      "collectionName": "plan_resources",
      "foreignKey": "plan_id",
      "name": "resources",
      "macro": "has_many",
      "resource_name": "PlanResource",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "plan_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "Plan::Translation",
      "collectionName": null,
      "foreignKey": "plan_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "auto_renew",
      "column": {
        "default": "0",
        "name": "auto_renew",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "show_in_sign_up_modal",
      "column": {
        "default": "0",
        "name": "show_in_sign_up_modal",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "uniqueness_identifier",
      "column": {
        "default": null,
        "name": "uniqueness_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "PlanResource",
      "collectionName": "plan_resources",
      "foreignKey": "plan_id",
      "name": "resources",
      "macro": "has_many",
      "resource_name": "PlanResource",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "plan_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    }
  ],
  "paramKey": "plan",
  "primaryKey": "id"
}

/** Frontend model for Plan. */
export default class Plan extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  autoRenew() {
    return this.readAttributeUnderscore("auto_renew")
  }

  /** @returns {boolean} */
  hasAutoRenew() {
    const value = this.autoRenew()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionWithInlineStyling() {
    return this.readAttributeUnderscore("description_with_inline_styling")
  }

  /** @returns {boolean} */
  hasDescriptionWithInlineStyling() {
    const value = this.descriptionWithInlineStyling()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showInSignUpModal() {
    return this.readAttributeUnderscore("show_in_sign_up_modal")
  }

  /** @returns {boolean} */
  hasShowInSignUpModal() {
    const value = this.showInSignUpModal()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniquenessIdentifier() {
    return this.readAttributeUnderscore("uniqueness_identifier")
  }

  /** @returns {boolean} */
  hasUniquenessIdentifier() {
    const value = this.uniquenessIdentifier()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionDa() {
    return this.readAttributeUnderscore("description_da")
  }

  /** @returns {boolean} */
  hasDescriptionDa() {
    const value = this.descriptionDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionEn() {
    return this.readAttributeUnderscore("description_en")
  }

  /** @returns {boolean} */
  hasDescriptionEn() {
    const value = this.descriptionEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionNo() {
    return this.readAttributeUnderscore("description_no")
  }

  /** @returns {boolean} */
  hasDescriptionNo() {
    const value = this.descriptionNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionSe() {
    return this.readAttributeUnderscore("description_se")
  }

  /** @returns {boolean} */
  hasDescriptionSe() {
    const value = this.descriptionSe()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  subTitle() {
    return this.readAttributeUnderscore("sub_title")
  }

  /** @returns {boolean} */
  hasSubTitle() {
    const value = this.subTitle()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subTitleDa() {
    return this.readAttributeUnderscore("sub_title_da")
  }

  /** @returns {boolean} */
  hasSubTitleDa() {
    const value = this.subTitleDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subTitleEn() {
    return this.readAttributeUnderscore("sub_title_en")
  }

  /** @returns {boolean} */
  hasSubTitleEn() {
    const value = this.subTitleEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subTitleNo() {
    return this.readAttributeUnderscore("sub_title_no")
  }

  /** @returns {boolean} */
  hasSubTitleNo() {
    const value = this.subTitleNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subTitleSe() {
    return this.readAttributeUnderscore("sub_title_se")
  }

  /** @returns {boolean} */
  hasSubTitleSe() {
    const value = this.subTitleSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  subscribeTo(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "subscribe_to",
        primaryKey: this.primaryKey(),
        collectionName: "plans",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-resource.js").default>} */
  resources() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["plan_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "resources",
        model: this,
        modelClass: PlanResource
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-resource.js").default>>} */
  loadResources() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["plan_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "resources",
        model: this,
        modelClass: PlanResource
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription.js").default>} */
  subscriptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["plan_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "subscriptions",
        model: this,
        modelClass: Subscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  loadSubscriptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["plan_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "subscriptions",
        model: this,
        modelClass: Subscription
      },
      {ransack}
    )
  }
}
